module.exports = __webpack_public_path__ + "static/media/mobile-app2.16c218e4.jpg";